import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";

// The signed-in fan's subscription for the destination being rendered, injected
// into the page payload by the render controller. These elements need no context
// binding: the subscription follows the session user, so an author can drop them
// anywhere rather than only inside a page that provides a subscription.
const EXAMPLE_SUBSCRIPTION = {
  status: "active",
  next_billing_date: 0,
  date_last_successful_billing: 0,
  date_subscribed: 0,
};

const EXAMPLE_NOTE = "Auto-renew is off. Your Pro Monthly plan ends in 3 days. You will move to Free Plan after that.";

const EXAMPLE_PLAN = {
  name: "Pro Monthly",
  price: 9.99,
  billing_frequency: "monthly",
  currency_code: "USD",
};

export const CurrentSubscriptionElementMixin = {
  mixins: [DynamicElementMixin],
  computed: {
    isEditable() {
      return false;
    },
    usesExampleSubscription() {
      if (this.editMode) {
        return true;
      }
      return !window.blclient?.data?.subscriberData;
    },
    currentSubscription() {
      if (this.usesExampleSubscription) {
        return EXAMPLE_SUBSCRIPTION;
      }
      return window.blclient.data.subscriberData;
    },
    currentSubscriptionNote() {
      if (this.usesExampleSubscription) {
        return EXAMPLE_NOTE;
      }
      const note = window.blclient.data.subscriptionNote;
      return note ? note : "";
    },
    currentSubscriptionPublicationId() {
      const fromSubscription = Number(this.currentSubscription?.publication_id);
      if (Number.isFinite(fromSubscription) && fromSubscription > 0) {
        return fromSubscription;
      }
      const fromHost = Number(window.blclient?.data?.themeDestinationId);
      if (Number.isFinite(fromHost) && fromHost > 0) {
        return fromHost;
      }
      return 0;
    },
    // An archived plan bills the fan on its successor, so that is the plan to
    // show — matching what the payment provider actually charges.
    currentSubscriptionPlan() {
      if (this.usesExampleSubscription) {
        return EXAMPLE_PLAN;
      }
      const data = window.blclient?.data ?? {};
      return data.effectiveSubscriptionPlanData ?? data.subscriptionPlanData ?? EXAMPLE_PLAN;
    },
  },
  methods: {
    formatSubscriptionDate(timestamp) {
      const seconds = Number(timestamp);
      if (!Number.isFinite(seconds) || seconds <= 0) {
        return "";
      }
      return new Date(seconds * 1000).toLocaleDateString(undefined, {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
    formatSubscriptionAmount(amount) {
      const value = Number(amount);
      if (!Number.isFinite(value)) {
        return "";
      }
      const currency = this.currentSubscriptionPlan?.currency_code || "USD";
      return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(value);
    },
  },
};
